import { useAppTranslation } from "@/utils";
import { Flex, Menu, Typography, usePaypingContext } from "@payping/web-components";
import { FeatherLeft, PhRChartPie, PhRScales } from "@payping/icons";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { Constants as refundRouterConstants } from "@/refund/routes";
import { useSelectedTab } from "./useSelectedTab";

const SaleMenu = () => {
  const { t } = useAppTranslation();
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;
  const selectedTab = useSelectedTab();

  // Menu items for both desktop and mobile
  const menuItems = [
    {
      key: DashboardRoutes.mySale.report.url,
      icon: <PhRChartPie />,
      label: <Link to={DashboardRoutes.mySale.report.url}>{t("mySale.tabs.report.title")}</Link>,
    },
    {
      key: DashboardRoutes.mySale.balanceAndWithdraw.url,
      icon: <PhRScales />,
      label: <Link to={DashboardRoutes.mySale.balanceAndWithdraw.url}>{t("mySale.tabs.balance&withdraws")}</Link>,
    },
    {
      key: refundRouterConstants.root.url,
      icon: <PhRScales />,
      label: <Link to={refundRouterConstants.root.url}>{t("refund.menu.root")}</Link>,
    },
  ];

  const desktopMenu = (
    <Flex vertical className={"tw:h-full!"}>
      {/* < تایتل "گزارشات" > */}
      <Typography.Text type={"secondary"}>{t("mainNav.tabs.sale")}</Typography.Text>

      {/* < منو گزارشات > */}
      <Menu mode="inline" className={"tw:h-full! tw:border-b-0!"} items={menuItems} selectedKeys={[selectedTab]} />
    </Flex>
  );

  const mobileMenu = (
    <Flex vertical className={"tw:p-4! tw:py-12!"}>
      {/* < تایتل "گزارشات" > */}
      <Typography.Title className={"tw:mb-8! font-bold"} level={4}>
        {t("mainNav.tabs.sale")}
      </Typography.Title>

      {/* <منو گزارشات > */}
      <Menu
        mode="inline"
        className="tw:border-0"
        selectedKeys={[selectedTab]}
        items={menuItems.map((item) => ({
          ...item,
          label: (
            <div className={"tw:flex tw:justify-between"}>
              <Flex justify={"space-between"}>{item.label}</Flex>
              <FeatherLeft width={14} />
            </div>
          ),
        }))}
      />
    </Flex>
  );

  return lg ? desktopMenu : mobileMenu;
};

export default SaleMenu;
